import { PropsWithChildren } from "react";

export const MainLayoutContent = ({ children }: PropsWithChildren) => {
  return <div className="lg:py-8">{children}</div>;
};
